import React from 'react';

import SinglePalletPacking from './SinglePalletPacking';
import PackingMarketplaceBarcode from '../PackingMarketplaceBarcode';

const SinglePallet = (props) => {
  const { barcode, packings, measurements, num, isOpen, onTogglePallet, requirements } = props;

  return (
    <div className="packing-main">
      <div className="packing-top">
        <div>
          <div style={{ fontWeight: '600' }}>{`#${num} | ${barcode}`}</div>
          {measurements ? (
            <div style={{ marginLeft: '10px' }} className="parameters">
              <span>{`ШхВхГ: ${(measurements.dimensions.width || 1200) / 10} x ${
                (measurements.dimensions.height || 1800) / 10
              } x ${(measurements.dimensions.depth || 800) / 10} cм`}</span>
              <span style={{ marginLeft: '8px' }}>{`Вес: ${
                measurements.weight ? measurements.weight + ' г' : '-'
              }`}</span>
            </div>
          ) : null}
        </div>

        <div
          className="show-packing-info-button"
          style={{ marginLeft: 'auto' }}
          onClick={onTogglePallet}
        >
          <div>Места</div>
          <i className={!isOpen ? 'fe-eye' : 'fe-eye-off'} />
        </div>
      </div>

      <PackingMarketplaceBarcode {...props} type="pallet" requirements={requirements} />

      {isOpen && packings?.length ? (
        <div className="packing-items">
          {packings.map((item, i) => (
            <SinglePalletPacking key={`${item.barcode}-${i}`} {...item} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default SinglePallet;
